import { Button } from "@mui/material";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IScheduleAppointment } from "../../../model";
import CancelSchedule from "./CancelSchedule";

interface ICancelScheduleButton {
  tasySchedulingTypeCode: string;
  appointment: IScheduleAppointment;
  onCancelled: () => void;
}

const CancelScheduleButton: React.FC<ICancelScheduleButton> = ({
  appointment,
  tasySchedulingTypeCode,
  onCancelled,
}) => {
  const { t } = useTranslation();
  const [openCancelModal, setOpenCancelModal] = useState(false);

  return (
    <>
      {tasySchedulingTypeCode && appointment && (
        <CancelSchedule
          data={appointment}
          type={tasySchedulingTypeCode}
          onClose={() => setOpenCancelModal(false)}
          open={openCancelModal}
          onCancelled={onCancelled}
        />
      )}
      <Button
        startIcon={<CloseRoundedIcon />}
        onClick={() => setOpenCancelModal(true)}
        color="error"
        variant="outlined"
      >
        {t("page.schedules.scheduleDetails.cancel.button")}
      </Button>
    </>
  );
};

export default memo(CancelScheduleButton);
